import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, NICmsContentField } from '@icms/core/content';
import { ProductComponent } from '../../../product/product/product.component';
import { IModelCarouselData } from '../model-carousel/model-carousel.interface';
import { AbstractProductsCarouselComponent, IAbstractProductCarouselData } from '../products-carousel/abstract-products-carousel.component';
import { fields, getAttributeOptions } from '../products-carousel/products-carousel.component';

let uid = 0;

@Component({
    selector: 'upsell-products-carousel',
    templateUrl: 'upsell-products-carousel.html',
    styleUrls: ['upsell-products-carousel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ICmsClientModule, TranslatePipe, ProductComponent, CarouselModule, NgClass, SizeClassDirective]
})
@ICmsComponent<PageComponentUpsellProductsCarouselComponent>({
    id: 'upsell-product-carousel-layout',
    name: 'Upsell Product Carousel Layout',
    tags: ['Product', 'Carousel'],
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'attribute',
            type: NICmsContentField.EFieldType.choice,
            title: 'Additional attribute',
            options: () => {
                if (typeof window !== 'undefined') {
                    return [{ key: undefined, value: undefined, title: 'undefined' }, ...getAttributeOptions()];
                }
                return [];
            },
            canShow: (data: IModelCarouselData) => (data?.variant as string) === 'attribute'
        },
        ...fields
    ]
})
export class PageComponentUpsellProductsCarouselComponent extends AbstractProductsCarouselComponent<IAbstractProductCarouselData> {
    uid = `upsell-products-carousel-${uid++}`;
}
